/**
 * Parses text with **bold** markers into segments for PDF/rich text rendering.
 * Use with @react-pdf/renderer: map segments to <Text style={bold ? {fontWeight: 'bold'} : {}}>{segment.text}</Text>
 */
export function parseBoldSegments(
  text: string
): Array<{ text: string; bold: boolean }> {
  if (!text) return [];
  const segments: Array<{ text: string; bold: boolean }> = [];
  const regex = /\*\*(.+?)\*\*/g;
  let lastIndex = 0;
  let match = regex.exec(text);
  while (match !== null) {
    if (match.index > lastIndex) {
      segments.push({ text: text.slice(lastIndex, match.index), bold: false });
    }
    segments.push({ text: match[1], bold: true });
    lastIndex = regex.lastIndex;
    match = regex.exec(text);
  }
  if (lastIndex < text.length) {
    segments.push({ text: text.slice(lastIndex), bold: false });
  }
  return segments;
}

export function capitalizeFirstLetter(inputString: string) {
  if (inputString.length === 0) {
    return inputString;
  }

  return inputString[0].toUpperCase() + inputString.slice(1);
}
